export default __webpack_public_path__ + "static/media/background-dark-3.46c5079c.jpg";